import { useState, useRef, useEffect } from 'react'
import { copyToClipboard } from '../../utils/clipboard'

/**
 * 공용 복사 버튼 — Explore 의 복사 UX 로 통일 (KBNL-141 후속).
 * 누르면 버튼 라벨이 1.5초간 '✓ 복사됨'(실패 시 '✗ 실패')으로 바뀌는 인라인 피드백.
 * HTTP(비-secure context) 폴백은 utils/clipboard.js 가 처리.
 *
 * props:
 *   value       복사할 텍스트
 *   label       기본 라벨 (기본 '복사')
 *   className   버튼 클래스 (기본 'btn-xs')
 *   style / disabled / title  그대로 전달
 */
export default function CopyButton({
  value, label = '복사', className = 'btn-xs', style, disabled, title,
}) {
  const [state, setState] = useState('idle')   // 'idle' | 'copied' | 'failed'
  const timerRef = useRef(null)

  useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current) }, [])

  const flash = (next) => {
    setState(next)
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setState('idle'), 1500)
  }

  const handleClick = () => {
    copyToClipboard(value ?? '')
      .then(() => flash('copied'))
      .catch(() => flash('failed'))
  }

  return (
    <button
      type="button"
      className={className}
      style={style}
      disabled={disabled}
      title={title}
      onClick={handleClick}
    >
      {state === 'copied' ? '✓ 복사됨' : state === 'failed' ? '✗ 실패' : label}
    </button>
  )
}
